var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setInfoMessage } from '@popup/multichain/actions/message.actions';
import { goBack, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { removeKey, setAccounts } from '@popup/steem/actions/account.actions';
import { loadActiveAccount } from '@popup/steem/actions/active-account.actions';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { Screen } from 'src/reference-data/screen.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const SUBSTRING_LENGTH = 15;
const AccountKeysListItem = ({ privateKey, publicKey, keyName, keyType, activeAccount, accounts, canDelete, isWrongKey, setInfoMessage, navigateToWithParams, removeKey, goBack, loadActiveAccount, }) => {
    const [isPrivateHidden, setIsPrivateHidden] = useState(true);
    const [isAuthorizedAccount, setIsAuthorizedAccount] = useState(false);
    useEffect(() => {
        setIsPrivateHidden(true);
    }, [activeAccount]);
    useEffect(() => {
        if (publicKey) {
            setIsAuthorizedAccount(KeysUtils.isAuthorizedAccount(publicKey));
        }
    }, [publicKey]);
    useEffect(() => { }, [publicKey, privateKey]);
    const copyToClipboard = (key) => {
        if (key) {
            navigator.clipboard.writeText(key.toString());
            setInfoMessage('popup_html_copied');
        }
    };
    const removePopupTagForAriaLabel = (keyName) => {
        return keyName.includes('popup_html_')
            ? keyName.split('popup_html_')[1]
            : keyName;
    };
    const handleClickOnRemoveKey = () => {
        const keyTypeLabel = getMessage(keyType.toLowerCase());
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: null,
            message: getMessage('html_popup_delete_key_confirm', [
                keyTypeLabel,
                activeAccount.name,
            ]),
            fields: [],
            title: 'html_popup_delete_key',
            afterConfirmAction: () => __awaiter(void 0, void 0, void 0, function* () {
                let actualNoKeyCheck = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.NO_KEY_CHECK);
                if (actualNoKeyCheck && actualNoKeyCheck[activeAccount.name]) {
                    delete actualNoKeyCheck[activeAccount.name];
                }
                yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.NO_KEY_CHECK, actualNoKeyCheck);
                removeKey(keyType);
                goBack();
            }),
        });
    };
    const goToAccount = (publicKey) => {
        const nextAccount = accounts.find((localAccount) => localAccount.name === publicKey.toString().split('@')[1]);
        if (nextAccount) {
            loadActiveAccount(nextAccount);
        }
    };
    return (React.createElement("div", { className: "account-keys-list-item" },
        React.createElement("div", { className: `top-panel ${!privateKey && !publicKey ? 'no-key' : ''}` },
            React.createElement("div", { className: "key-name-container" },
                React.createElement("span", { className: "key-name" },
                    getMessage(keyName),
                    " "),
                isWrongKey && (React.createElement(CustomTooltip, { message: "popup_html_wrong_key_tooltip_text", position: 'bottom', additionalClassName: "tool-tip-custom" },
                    React.createElement(SVGIcon, { icon: SVGIcons.GLOBAL_ERROR })))),
            publicKey && privateKey && canDelete && (React.createElement(SVGIcon, { dataTestId: `icon-remove-key-${removePopupTagForAriaLabel(keyName)}`, onClick: () => handleClickOnRemoveKey(), icon: SVGIcons.GLOBAL_DELETE, className: "remove-button" })),
            !privateKey && !publicKey && (React.createElement(SVGIcon, { dataTestId: `icon-add-key-${removePopupTagForAriaLabel(keyName)}`, onClick: () => navigateToWithParams(Screen.SETTINGS_ADD_KEY, keyType), icon: SVGIcons.GLOBAL_ADD_CIRCLE, className: "add-key-icon" }))),
        (publicKey || privateKey) && (React.createElement("div", { className: "keys-panel-content" },
            !isAuthorizedAccount && (React.createElement(React.Fragment, null,
                React.createElement("div", { "data-testid": `clickeable-account-key-${removePopupTagForAriaLabel(keyName)}`, className: `private-key key-field ${isPrivateHidden ? 'hidden' : 'show'}`, onClick: () => isPrivateHidden
                        ? setIsPrivateHidden(false)
                        : copyToClipboard(privateKey) }, isPrivateHidden
                    ? getMessage('popup_accounts_reveal_private')
                    : `${privateKey === null || privateKey === void 0 ? void 0 : privateKey.substring(SUBSTRING_LENGTH, 0)}...${privateKey === null || privateKey === void 0 ? void 0 : privateKey.toString().slice(-SUBSTRING_LENGTH)}`),
                React.createElement("div", { className: `public-key key-field`, onClick: () => copyToClipboard(publicKey) }, `${publicKey === null || publicKey === void 0 ? void 0 : publicKey.substring(SUBSTRING_LENGTH, 0)}...${publicKey === null || publicKey === void 0 ? void 0 : publicKey.toString().slice(-SUBSTRING_LENGTH)}`))),
            isAuthorizedAccount && publicKey && (React.createElement("div", { "data-testid": "using-authorized-account", className: "using-authorized-account", onClick: () => goToAccount(publicKey) }, getMessage('html_popup_using_authorized_account', [
                publicKey,
            ])))))));
};
const mapStateToProps = (state) => {
    return {
        accounts: state.steem.accounts,
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    setInfoMessage,
    setAccounts,
    navigateToWithParams,
    removeKey,
    goBack,
    loadActiveAccount,
});
export const AccountKeysListItemComponent = connector(AccountKeysListItem);
